import {
    FETCH_IDEAS,
    GET_IDEA,
    SELECT_IDEA,
    DELETE_IDEA,
    UPDATE_IDEA,
    CREATE_IDEA,
    REDIRECT_TO_IDEA,
    UNSELECT_IDEA,
} from '../actions/ideas'
import { SAVE_ATTACHMENT, DELETE_ATTACHMENT } from '../actions/attachments'
import {
    CREATE_COMMENT,
    UPDATE_COMMENT,
    DELETE_COMMENT,
} from '../actions/comments'
import { LIKE_IDEA, UNLIKE_IDEA } from '../actions/like-idea'
import { LIKE_COMMENT, UNLIKE_COMMENT } from '../actions/like-comment'
import { UPDATE_IDEA_STATUS } from '../actions/idea-status'
import { CREATE_FEEDBACK, DELETE_FEEDBACK } from '../actions/feedback'

const initialState = {
    selectedIdeaId: undefined,
    idea: undefined,
    ideaList: undefined,
    pagination: undefined,
    justSubmitted: false,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SELECT_IDEA:
            return {
                ...state,
                selectedIdeaId: action.payload,
            }
            
        case UNSELECT_IDEA:
            return {
                ...state,
                selectedIdeaId: undefined,
                idea: undefined
            }

        case CREATE_IDEA:
        case UPDATE_IDEA:
            return {
                ...state,
                justSubmitted: true,
                idea: action.payload,
                selectedIdeaId: action.payload._id
            }

        case REDIRECT_TO_IDEA:
            return {
                ...state,
                justSubmitted: false,
            }

        case GET_IDEA:
        case SAVE_ATTACHMENT:
        case DELETE_ATTACHMENT:
        case CREATE_COMMENT:
        case UPDATE_COMMENT:
        case DELETE_COMMENT:
        case CREATE_FEEDBACK:
        case DELETE_FEEDBACK:
        case LIKE_IDEA:
        case UNLIKE_IDEA:
        case LIKE_COMMENT:
        case UNLIKE_COMMENT:
        case UPDATE_IDEA_STATUS:
            return {
                ...state,
                idea: action.payload,
            }

        case DELETE_IDEA:
            return {
                ...state,
                idea: undefined,
                selectedIdeaId: undefined,
            }

        case FETCH_IDEAS:
            return {
                ...state,
                ideaList: action.payload.data,
                pagination: {
                    skip: action.payload.skip,
                    limit: action.payload.limit,
                    size: action.payload.size,
                },
            }

        default:
            return state
    }
}
